import React, {Component} from "react";
import DisplayText from "./DisplayText";
import DisplayInput from "./DisplayInput";
import DisplayFooter from "./DisplayFooter";
import DisplayHeader from "./DisplayHeader";
import axios from "axios";
import ReactToPrint from "react-to-print";
import DisplayDivider from "./DisplayDivider";
import DisplayGroup from "./DisplayGroup";
import MesureStore from "../../../Appointments/Mesures/MesureStore";
import {RequestState} from "../../../Shared/StateHelper";
import Loader from "../../../Shared/Loader";
import Helper from "../../../Shared/Helper";
import PrescriptionStore from "../../../Appointments/PrescriptionStore";
import {ReportTokens} from "../../../Shared/Enums/Reports";
import DisplayImage from "./DisplayImage";
import {observer} from "mobx-react";
import Mesure from "../../../Appointments/Mesures/Mesure";
import {Mesures} from "../../../Shared/Enums/Enums";

const _ = require('lodash');
const pageStyle = `
@media print {
   body {
       display: block;
       box-sizing: border-box;   
       padding: 0 15mm;
       height: auto;
       fontFamily: Arial, sans-serif;
       width: 100%;
       margin: 0
   }
   @page {
        margin: 40px 20px;
        size: auto;   /* auto is the initial value */
   }
   img {
        max-width: 100%;
        max-height: 100%;
   }
   #unbreakable {
        display: grid;
        page-break-inside: avoid;
        * {
            page-break-inside: avoid;
        }
    }
    p {
     min-height: 1em;
    }
}
`;

@observer
export default class DisplayBlocks extends Component {

    constructor(props) {
        super(props);
        this.renderBlock = this.renderBlock.bind(this)
        this.display = this.display.bind(this)
        this.debouncedSetValues = _.debounce(this.setValues, 1000)
        this.state = {
            values: {},
            display: <div/>,
            hiddenBlocks: [],
            status: RequestState.IDLE
        }
    }

    componentDidMount() {
        if (this.props.template) this.getValues()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.template?.id !== prevProps.template?.id) this.getValues()

        if (this.props.hiddenBlocks !== this.state.hiddenBlocks && this.props.hiddenBlocks !== prevProps.hiddenBlocks) {
            this.debouncedSetValues()
        }
        if (this.state.values !== prevState.values) this.setValuesFromDefault()
    }

    componentWillUnmount() {
        this.debouncedSetValues.flush()
    }

    getValues() {
        this.setState({status: RequestState.LOADING})
        if (this.props.appointment_id !== undefined && this.props.template?.id) {
            axios.get("/orthoptistes/reports/values", {
                params: {
                    appointment_id: this.props.appointment_id,
                    template_id: this.props.template?.id
                }
            }).then((resp) => {
                this.setState({
                    values: resp.data.values,
                    hiddenBlocks: resp.data.hiddenBlocks
                }, () => {
                    this.setValuesFromDefault()
                    this.props.setHiddenBlocks(resp.data.hiddenBlocks || [])
                })
            })
        } else this.setState({status: RequestState.SUCCESS})
    }

    setValues() {
        if (this.props.appointment_id !== undefined && this.props.template?.id !== undefined) {
            axios.patch("/orthoptistes/reports/values", {
                appointment_id: this.props.appointment_id,
                template_id: this.props.template?.id,
                values: this.state.values,
                hiddenBlocks: this.props.hiddenBlocks
            }).then((resp) => {
            })
        }
    }

    // runs through all inputs, and if there is a default text, and no value, set the value to the default text (formatted if needed)
    setValuesFromDefault() {
        let newValues = {...this.state.values}

        const computeBlock = (block) => {
            if (block.type === "GROUP") {
                block.data.blocks.forEach((block) => {
                    computeBlock(block)
                })
            }
            if (block.type === "INPUT") {
                const inputs = block.data
                inputs.forEach((input) => {
                    if (input.type !== "TEXT" || !input.default_text) return
                    let value = this.state.values[input.id]
                    if (!value) newValues[input.id] = this.formatText(input.default_text)
                })
            }
        }

        const template = this.props.template
        if (!template) return
        template.blocks.forEach((block) => {
            if (block.type === "GROUP") {
                block.data.blocks.forEach((block) => {
                    computeBlock(block)
                })
            } else computeBlock(block)

        })
        if (JSON.stringify(newValues) === JSON.stringify(this.state.values)) this.setState({status: RequestState.SUCCESS})
        else this.setState({values: newValues, status: RequestState.SUCCESS}, () => this.setValues())
    }

    computeValue = (token, value) => {
        return token.format(value)
    }

    formatText(text) {
        if (!this.props.appointment_pending) return text
        console.log(text)
        if (text) {
            const tokens = Object.values(ReportTokens).filter((token) => text.includes(token.token) || text.includes(token.token.replaceAll("_", "-")))
            console.log(tokens)
            tokens.forEach((token) => {
                const mesure = MesureStore.existingMesures.find((mesure) => mesure.titre === token.mesure_type)
                let value = mesure ? mesure[token.value] : ""
                value = this.computeValue(token, value)
                text = text.replace(new RegExp(token.token, "g"), value || "")
                text = text.replace(new RegExp(token.token.replaceAll("_", "-"), "g"), value || "")
            })

            // tension and pachymetry
            const tension = MesureStore.existingMesures.find((mesure) => mesure.titre === Mesures.TENSION.name)
            if(tension) {
                const og_token = "!og_tension!"
                const od_token = "!od_tension!"
                text = text.replaceAll(og_token, tension.og_tension ?? "")
                text = text.replaceAll(od_token, tension.od_tension ?? "")
                text = text.replaceAll(og_token?.replaceAll("_", "-"), tension.og_tension ?? "")
                text = text.replaceAll(od_token?.replaceAll("_", "-"), tension.od_tension ?? "")
            }
            const pachymetry = MesureStore.existingMesures.find((mesure) => mesure.titre === Mesures.PACHYMETRY.name)
            if(pachymetry) {
                const og_token = "!og_pachymetrie!"
                const od_token = "!od_pachymetrie!"
                text = text.replaceAll(og_token, pachymetry.og_pachymetrie ?? "")
                text = text.replaceAll(od_token, pachymetry.od_pachymetrie ?? "")
                text = text.replaceAll(og_token.replaceAll("_", "-"), pachymetry.og_pachymetrie ?? "")
                text = text.replaceAll(od_token.replaceAll("_", "-"), pachymetry.od_pachymetrie ?? "")
            }
            console.log(tension, pachymetry)
            let gender = null
            switch (MesureStore.patient.gender) {
                case false:
                    gender = "Homme"
                    break
                case true:
                    gender = "Femme"
                    break
            }

            const general_tokens = [
                {token: "!date!", value: MesureStore.appointment_date},
                {token: "!nom_patient!", value: Helper.formatName(MesureStore.patient.prenom, MesureStore.patient.nom)},
                {token: "!email_patient!", value: MesureStore.patient.email},
                {token: "!telephone_patient!", value: MesureStore.patient.telephone},
                {token: "!ddn_patient!", value: Helper.formatDate(MesureStore.patient.birthday)},
                {token: "!genre_patient!", value: gender},
                {token: "!nss_patient!", value: MesureStore.patient.num_carte_vitale},
                {token: "!nom_ortho!", value: Helper.formatName(MesureStore.metadata.orthoptist_firstname, MesureStore.metadata.orthoptist_lastname)},
                {token: "!adresse_ortho!", value: MesureStore.metadata.orthoptist_address},
                {token: "!ville_ortho!", value: MesureStore.metadata.orthoptist_city},
                {token: "!cp_ortho!", value: MesureStore.metadata.orthoptist_postal_code},
                {token: "!tel_ortho!", value: MesureStore.metadata.orthoptist_phone},
                {token: "!email_ortho!", value: MesureStore.metadata.orthoptist_email},
                {token: "!cabinet_ortho!", value: MesureStore.metadata.orthoptist_office_name},
                {token: "!adeli_ortho!", value: MesureStore.metadata.orthoptist_adeli},
                {token: "!prescription!", value: PrescriptionStore.prescriptionText},
                {token: "!anamnese!", value: MesureStore.anamnesis},
                {token: "!orthoptic_text!", value: MesureStore.orthoptic_text}, // legacy
                {token: "!orthoptie!", value: MesureStore.orthoptic_text},
                {token: "!private_comment!", value: MesureStore.private_comment}, // legacy
                {token: "!commentaire_prive!", value: MesureStore.private_comment},
                {token: "!patient_history!", value: MesureStore.patient.history}, // legacy
                {token: "!historique_patient!", value: MesureStore.patient.history},
                {token: "!commentaire_ophta!", value: MesureStore.comment_for_ophtalmologist}
            ]

            general_tokens.forEach((t) => {
                text = text.replace(new RegExp(t.token, "g"), t.value || "")
                text = text.replace(new RegExp(t.token.replaceAll("_", "-"), "g"), t.value || "")
            })
            return text
        } else return ""
    }


    onChange(values) {
        this.setState({values: values}, () => this.debouncedSetValues())
    }

    renderBlock(block) {
        if (this.props.hiddenBlocks.includes(block.id)) return null;
        // change null values to empty strings
        const values = Object.entries(this.state.values).reduce((acc, [key, value]) => {
            acc[key] = value
            return acc
        }, {})
        const types = {
            "HEADER": <DisplayHeader block={block}/>,
            "INPUT": <DisplayInput
                appointment_pending={this.props.appointment_pending}
                block={block} values={values}
                onChange={(values) => this.onChange(values)}/>,
            "TEXT": <DisplayText block={block}/>,
            "FOOTER": <DisplayFooter block={block}/>,
            "DIVIDER": <DisplayDivider block={block}/>,
            "IMAGE": <DisplayImage block={block}/>,
            "GROUP": <DisplayGroup block={block}
                                   hiddenBlocks={this.props.hiddenBlocks}
                                   values={values}
                                   onChange={(values) => this.onChange(values)}
                                   appointment_pending={this.props.appointment_pending}
            />,
        }
        return types[block.type] || null
    }

    compute(block) {
        if (this.props.hiddenBlocks.includes(block.id)) return null;
        switch (block.type) {
            case "HEADER":
                return DisplayHeader.preview(block)
            case "INPUT":
                return DisplayInput.preview(block, this.state.values, {
                    patient: MesureStore.patient, appointment: {date: MesureStore.appointment_date}
                })
            case "TEXT":
                return DisplayText.preview(block)
            case "FOOTER":
                return DisplayFooter.preview(block)
            case "DIVIDER":
                return DisplayDivider.preview(block)
            case "IMAGE":
                return DisplayImage.preview(block)
            case "GROUP":
                return DisplayGroup.preview(block, this.props.hiddenBlocks, this.state.values, {
                    patient: MesureStore.patient, appointment: {date: MesureStore.appointment_date}
                })
        }
    }

    display() {
        if (this.props.template?.blocks) {
            return <div className="valign-wrapper"
                        style={{
                            width: "21cm",
                            height: "100%",
                            justifyContent: "center",
                            fontSize: "12px",
                            fontFamily: "Arial"
                        }}
                        ref={el => (this.toPrint = el)}>
                <div style={{width: "90%", height: "90%", display: "flex", flexDirection: "column"}}>
                    {this.props.template.blocks.map((block, index) =>
                        <div key={index} style={{marginTop: `${block.type === "FOOTER" ? "auto" : ""}`}}>
                            {this.compute(block)}
                        </div>
                    )}
                </div>
            </div>
        } else return <div ref={el => (this.toPrint = el)}/>;
    }

    renderPrinter = () => {
        return (
            <ReactToPrint
                pageStyle={pageStyle}
                documentTitle={this.props.template.name}
                trigger={() => <p className="center"
                                  style={{width: "100%", backgroundColor: "#fbfbfd"}}><a
                    className="blue darken-2 z-depth-0 btn-small"><i
                    className="material-icons left">print</i>Imprimer</a></p>}
                content={() => this.toPrint}
            />
        )
    }

    render() {
        if (this.state.status === RequestState.LOADING) return <div style={{margin: 20}}><Loader/></div>
        if (this.props.template) {
            return <div>
                <div className="valign-wrapper" style={{justifyContent: "center"}}>
                    <div className={`${this.props.appointment_id === undefined ? "hide" : ""}`}>
                        {this.renderPrinter()}
                    </div>
                </div>
                <div className="card transparent "
                     style={{
                         width: "210mm",
                         minHeight: "297mm",
                         padding: 0,
                         fontSize: "12px",
                         fontFamily: "Arial"
                     }}>
                    <div className="valign-wrapper"
                         style={{width: "100%", height: "100%", justifyContent: "center"}}>
                        <div style={{width: "90%", display: "flex", flexDirection: "column", padding: "30px 0"}}>
                            {this.props.template.blocks ? (this.props.template.blocks.map((block, index) =>
                                <div id="block" key={index}
                                     style={{marginTop: `${block.type === "FOOTER" ? "auto" : ""}`}}
                                     onClick={() => this.props.onBlockClick(block)}>
                                    {this.renderBlock(block)}
                                </div>
                            )) : (<div/>)}
                        </div>
                    </div>
                </div>
                <div className="hide">
                    {/*<div style={{width: "210mm"}}>*/}

                    {this.display()}
                    {/*</div>*/}
                </div>
            </div>
        } else return null
    }

    static computeSize(size) {
        if (size === "small") {
            return "1em"
        } else if (size === "large") {
            return "1.5em"
        } else return "1.2em"
    }
}

DisplayBlocks.defaultProps = {
    values: {},
    hiddenBlocks: [],
    appointment_id: undefined,
    appointment_pending: false
}